import * as XLSX from "xlsx";

export const parseBOQTemplate = (rows, entityUnits = []) => {
  const providingFixingDetails = [];
  const unitErrors = [];
  let currentSection = null;

  // Format unit only if entityUnits are provided
  const getFormattedUnit = (rawUnit, rowIndex, context) => {
    if (!rawUnit) return "";

    const unitCode = rawUnit?.toLowerCase()?.trim();

    if (entityUnits.length > 0) {
      const matched = entityUnits.find((u) => u?.code?.toLowerCase() === unitCode);
      if (matched) {
        return `${matched.code} (${matched.name})`;
      } else {
        unitErrors.push(`Row ${rowIndex + 1} (${context}): Invalid unit code "${rawUnit}".`);
      }
    }

    return rawUnit;
  };

  const formatQuantity = (value) => {
    if (value === undefined || value === null || value === "") return "";
    const strValue = String(value).trim();
    if (!/^\d*\.?\d*$/.test(strValue)) return ""; 
    
    const [intPart, decimalPart] = strValue.split(".");
    if (decimalPart) {
      return `${intPart}.${decimalPart.slice(0, 2)}`.replace(/\.$/, "");
    }
    return intPart;
  };
   const formatBudget = (value) => {
      if (value === undefined || value === null || value === "") return "";
      const strValue = String(value).trim();
      if (!/^\d*\.?\d*$/.test(strValue)) return "";
      const [intPart, decimalPart] = strValue.split(".");
      if (decimalPart) {
        return `${intPart}.${decimalPart.slice(0, 3)}`.replace(/\.$/, "");
      }
      return intPart;
    };
  rows.forEach((row, index) => {
    if (index === 0) return; // Skip header row
    const [sNoRaw, description, unit, quantity, brands, budget] = row;
    const sNo = sNoRaw ? String(sNoRaw).trim() : null; // Convert sNo to string and trim

    if (sNo && /^S\d+$/.test(sNo)) {
      // New Section
      currentSection = {
        sectionName: description,
        scopes: [],
      };
      providingFixingDetails.push(currentSection);
    } else if (sNo && /^\d+$/.test(sNo)) {
      // New Scope (integer sNo)
      const newScope = {
        scopeOfWork: description || "",
        quantity: formatQuantity(quantity) || "",
        unit: getFormattedUnit(unit, index, "Scope") || "",
        budget: formatBudget(budget) || 0,
        preferredBrands: (brands || "").split(",").map((b) => b.trim()),
        materials: [],
      };
      currentSection?.scopes.push(newScope);
    } else if (sNo && /^\d+\.\d+$/.test(sNo)) {
      // New Material (decimal sNo)
      const parentScope = currentSection?.scopes[currentSection.scopes.length - 1];
      if (parentScope) {
        parentScope.materials.push({
          name: description || "",
          quantity: formatQuantity(quantity) || "",
          unit: getFormattedUnit(unit, index, "Material") || "",
          budget: formatBudget(budget) || 0,
          brands: (brands || "").split(",").map((b) => b.trim()),
          specifications: "",
        });
      }
    }
  });

  return { parsedData: providingFixingDetails, unitErrors };
};

export const validateSections = (sections, unitErrors = []) => {
  const errors = [...unitErrors];

  sections.forEach((section, index) => {
    if (!section.sectionName || section.sectionName.trim() === "") {
      errors.push(`Section name not added for section ${index + 1}.`);
    }

    if (!section.scopes || section.scopes.length === 0) {
      errors.push(`Section ${index + 1} must have at least one scope.`);
    }

    section.scopes?.forEach((scope, scopeIndex) => {
      if (!scope.scopeOfWork) {
        errors.push(
          `Section ${index + 1}, Scope ${scopeIndex + 1}: Description required.`
        );
      }

      const hasMaterials = scope.materials && scope.materials.length > 0;

      if (!hasMaterials) {
        if (!scope.quantity) {
          errors.push(
            `Section ${index + 1}, Scope ${scopeIndex + 1}: Quantity required.`
          );
        }

        if (!scope.unit) {
          errors.push(
            `Section ${index + 1}, Scope ${scopeIndex + 1}: Unit required.`
          );
        }
      }
    });
  });

  return errors;
};

